import { AppDefinition } from '../../types/apps';

export const SKILLWIZARD_EVENTS = {
  CREATED: 'SKILLWIZARD_CREATED',
  UPDATED: 'SKILLWIZARD_UPDATED',
  SKILL_GENERATED: 'SKILLWIZARD_SKILL_GENERATED',
} as const;

export const SkillWizardAppDefinition: AppDefinition = {
  appId: 'skill-wizard',
  name: 'Skill Wizard',
  version: '1.0.0',
  description:
    'Build and use form-based wizards that produce configured Skill entities. ' +
    'Creators author sections of typed questions with a worked input → output example. ' +
    'End-users answer the questions to generate a Skill they can use elsewhere in River.',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'MagicWand',
    phosphorWeight: 'duotone',
    color: '#10b981',
    metadata: { source: 'app', appId: 'skill-wizard', isAppIcon: true },
  },

  entityIcons: {
    SkillWizard: {
      type: 'phosphor',
      phosphorIcon: 'MagicWand',
      phosphorWeight: 'duotone',
      color: '#10b981',
    },
  },

  events: SKILLWIZARD_EVENTS,
  entityTypes: ['SkillWizard'],

  searchableSkeletonFields: {
    SkillWizard: ['description', 'tags'],
  },

  component: 'SkillWizardApp',
  requiresProps: false,
  requiresEntity: true,

  agenticToolIds: [
    'skillwizard_create',
    'skillwizard_read',
    'skillwizard_update',
    'skillwizard_generate_skill',
  ],

  actions: {},
  hidden: true,
};
